// Nynolia — theme JS

(function () {
  'use strict';

  // ---- Policy page: force small heading ----
  if (window.location.pathname.startsWith('/policies/')) {
    function shrinkPolicyHeadings() {
      document.querySelectorAll('h1, h2').forEach(function(el) {
        el.style.cssText = 'font-size: 36px !important; font-weight: 400 !important; line-height: 1.4 !important; letter-spacing: 0.04em !important;';
      });
    }
    document.addEventListener('DOMContentLoaded', shrinkPolicyHeadings);
    setTimeout(shrinkPolicyHeadings, 300);
    setTimeout(shrinkPolicyHeadings, 800);
  }

  // ---- Replace shop-name h1 with ornament (confirmation pages) ----
  function replaceShopHeading() {
    document.querySelectorAll('h1').forEach(function(el) {
      if (el.querySelector('img')) return; // already replaced
      var text = el.textContent.trim().toUpperCase();
      if (text === 'NYNOLIA' || text.startsWith('NYNOLIA')) {
        el.innerHTML = '<img src="' + window.nyOrnamentUrl + '" alt="Nynolia" style="width:180px;height:auto;display:block;margin:0 auto;" />';
        el.style.cssText = 'text-align:center;margin-bottom:32px;';
      }
    });
  }
  document.addEventListener('DOMContentLoaded', replaceShopHeading);
  setTimeout(replaceShopHeading, 300);
  setTimeout(replaceShopHeading, 800);
  setTimeout(replaceShopHeading, 1600);

  // ---- Ticker ----
  function initTicker() {
    const ticker = document.getElementById('ny-ticker');
    if (!ticker) return;
    const spans = ticker.querySelectorAll('span');
    if (!spans.length) return;
    let idx = 0;
    spans[0].classList.add('on');
    setInterval(function () {
      spans[idx].classList.remove('on');
      idx = (idx + 1) % spans.length;
      spans[idx].classList.add('on');
    }, 4200);
  }

  // ---- Scrolled nav ----
  function initScrolledNav() {
    const nav = document.querySelector('.ny-nav');
    if (!nav) return;
    function update() { nav.classList.toggle('is-scrolled', window.scrollY > 20); }
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  // ---- Mega-menu ----
  function initMegaMenu() {
    const nav = document.querySelector('.ny-nav');
    if (!nav) return;
    const megas = nav.querySelectorAll('.ny-mega');
    const triggerLinks = nav.querySelectorAll('.ny-nav-link[data-mega]');
    const otherLinks = nav.querySelectorAll('.ny-nav-link:not([data-mega])');

    function hideAll() { megas.forEach(function (m) { m.classList.remove('is-open'); }); }

    triggerLinks.forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        hideAll();
        var target = link.dataset.mega;
        var mega = nav.querySelector('.ny-mega[data-line="' + target + '"]');
        if (mega) mega.classList.add('is-open');
      });
    });

    otherLinks.forEach(function (link) {
      link.addEventListener('mouseenter', hideAll);
    });

    nav.addEventListener('mouseleave', hideAll);

    megas.forEach(function (mega) {
      mega.addEventListener('mouseleave', hideAll);
    });
  }

  // ---- Cart drawer ----
  var CartDrawer = {
    drawer: null,
    backdrop: null,
    body: null,
    foot: null,

    init: function () {
      this.drawer = document.getElementById('ny-cart-drawer');
      this.backdrop = document.getElementById('ny-cart-backdrop');
      if (!this.drawer) return;
      this.body = this.drawer.querySelector('.ny-drawer-body');
      this.foot = this.drawer.querySelector('.ny-drawer-foot');

      var self = this;

      if (this.backdrop) {
        this.backdrop.addEventListener('click', function () { self.close(); });
      }

      var closeBtn = this.drawer.querySelector('.ny-drawer-close');
      if (closeBtn) closeBtn.addEventListener('click', function () { self.close(); });

      document.querySelectorAll('[data-open-cart]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.open(); });
      });

      document.addEventListener('submit', function (e) {
        var form = e.target.closest('[data-ny-atc]');
        if (!form) return;
        e.preventDefault();
        self.addItem(form);
      });
    },

    open: function () {
      if (!this.drawer) return;
      this.fetchAndRender();
      this.drawer.classList.add('on');
      if (this.backdrop) this.backdrop.classList.add('on');
      document.body.style.overflow = 'hidden';
    },

    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.remove('on');
      if (this.backdrop) this.backdrop.classList.remove('on');
      document.body.style.overflow = '';
    },

    addItem: function (form) {
      var self = this;
      var data = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: data,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      }).then(function () {
        self.open();
      }).catch(function (err) {
        console.error(err);
      });
    },

    fetchAndRender: function () {
      var self = this;
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        self.render(cart);
        self.updateBadge(cart.item_count);
      });
    },

    updateBadge: function (count) {
      document.querySelectorAll('.ny-cart-badge').forEach(function (b) {
        b.textContent = count;
        b.style.display = count > 0 ? 'inline-flex' : 'none';
      });
    },

    formatPrice: function (cents) {
      return '€ ' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 0 });
    },

    render: function (cart) {
      var self = this;
      var titleCount = this.drawer.querySelector('.ny-drawer-title span');
      if (titleCount) titleCount.textContent = '(' + cart.item_count + ')';

      if (cart.item_count === 0) {
        this.body.innerHTML = '<div class="ny-drawer-empty">'
          + '<img src="' + (window.nyOrnamentUrl || '') + '" alt="" style="width:72px;opacity:0.5;margin:0 auto 20px;display:block" />'
          + '<p class="ny-drawer-empty-title">Your bag is empty</p>'
          + '<p class="ny-drawer-empty-sub">Discover the new Kashmir & Silk edition.</p>'
          + '<a href="/collections/all" class="ny-btn ny-btn-dark" style="margin:0 auto">Continue browsing</a>'
          + '</div>';
        if (this.foot) this.foot.style.display = 'none';
        return;
      }

      if (this.foot) this.foot.style.display = 'flex';

      this.body.innerHTML = cart.items.map(function (item) {
        var img = item.image ? '<img src="' + item.image + '" alt="" class="ny-cart-item-img" />' : '<div class="ny-cart-item-img" style="background:var(--ny-rule)"></div>';
        return '<div class="ny-cart-item">'
          + img
          + '<div class="ny-cart-item-body">'
          + '<div class="ny-cart-item-line">' + (item.product_type || '') + '</div>'
          + '<div class="ny-cart-item-name">' + item.product_title + '</div>'
          + '<div class="ny-cart-item-meta">' + (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '') + '</div>'
          + '<div class="ny-cart-item-row">'
          + '<div class="ny-qty">'
          + '<button type="button" data-action="dec" data-key="' + item.key + '" data-qty="' + item.quantity + '">&#x2212;</button>'
          + '<span>' + item.quantity + '</span>'
          + '<button type="button" data-action="inc" data-key="' + item.key + '" data-qty="' + item.quantity + '">+</button>'
          + '</div>'
          + '<button type="button" class="ny-cart-remove" data-action="remove" data-key="' + item.key + '">Remove</button>'
          + '</div></div>'
          + '<div class="ny-cart-item-price">' + self.formatPrice(item.line_price) + '</div>'
          + '</div>';
      }).join('');

      var subtotalEl = this.drawer.querySelector('.ny-drawer-subtotal');
      if (subtotalEl) subtotalEl.textContent = this.formatPrice(cart.total_price);

      this.body.querySelectorAll('[data-action]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.dataset.key;
          var qty = parseInt(btn.dataset.qty, 10);
          var action = btn.dataset.action;
          if (action === 'remove') self.changeQty(key, 0);
          else if (action === 'inc') self.changeQty(key, qty + 1);
          else if (action === 'dec') self.changeQty(key, Math.max(0, qty - 1));
        });
      });
    },

    changeQty: function (key, qty) {
      var self = this;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () { self.fetchAndRender(); });
    }
  };

  // ---- PDP gallery thumbnails (desktop) ----
  function initPDPGallery() {
    var thumbs = document.querySelectorAll('.ny-pdp-thumbs button[data-src]');
    var mainImg = document.getElementById('ny-main-img');
    if (!thumbs.length || !mainImg) return;

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        thumbs.forEach(function (b) { b.classList.remove('on'); });
        btn.classList.add('on');
        mainImg.src = btn.dataset.src;
      });
    });
  }

  // ---- PDP mobile swipe carousel dots ----
  function initPDPCarousel() {
    var carousel = document.getElementById('ny-pdp-carousel');
    var dotsEl = document.getElementById('ny-pdp-dots');
    if (!carousel || !dotsEl) return;
    var dots = dotsEl.querySelectorAll('.ny-pdp-dot');
    if (!dots.length) return;

    carousel.addEventListener('scroll', function () {
      var idx = Math.round(carousel.scrollLeft / carousel.offsetWidth);
      dots.forEach(function (d, i) { d.classList.toggle('on', i === idx); });
    }, { passive: true });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.dataset.index, 10);
        carousel.scrollTo({ left: idx * carousel.offsetWidth, behavior: 'smooth' });
      });
    });
  }

  // ---- Accordions ----
  function initAccordions() {
    document.querySelectorAll('.ny-acc-head').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var acc = btn.closest('.ny-acc');
        var isOpen = acc.classList.contains('on');
        var parent = acc.parentElement;
        if (parent) parent.querySelectorAll('.ny-acc').forEach(function (a) { a.classList.remove('on'); });
        if (!isOpen) acc.classList.add('on');
        var ic = btn.querySelector('.ny-acc-ic');
        if (ic) ic.textContent = acc.classList.contains('on') ? '−' : '+';
      });
    });
  }

  // ---- Variant picker (PDP) ----
  function initVariantPicker() {
    var form = document.querySelector('[data-ny-atc]');
    if (!form) return;
    var variants = window.nyProductVariants || [];
    if (!variants.length) return;

    var idInput = form.querySelector('.ny-variant-id');
    var submitBtn = form.querySelector('[data-submit-btn]');
    var hintEl = form.querySelector('.ny-pdp-hint');

    var selected = {};

    // Seed from first available variant
    var first = variants.find(function (v) { return v.available; }) || variants[0];
    if (first) {
      first.options.forEach(function (val, i) { selected[i] = val; });
    }

    function findVariant() {
      return variants.find(function (v) {
        return Object.keys(selected).every(function (i) { return v.options[parseInt(i, 10)] === selected[i]; });
      });
    }

    function updateUI() {
      var variant = findVariant();
      if (variant && idInput) idInput.value = variant.id;

      var allSelected = Object.keys(selected).length === (first ? first.options.length : 0);

      if (submitBtn) {
        if (!variant || !variant.available) {
          submitBtn.disabled = true;
          submitBtn.textContent = variant ? 'Sold Out' : 'Select size';
        } else {
          submitBtn.disabled = false;
          submitBtn.textContent = allSelected ? 'Add to Shopping Bag' : 'Select size';
        }
      }

      if (hintEl) {
        hintEl.style.display = allSelected ? 'none' : 'block';
      }

      var priceEl = document.querySelector('.ny-pdp-price');
      if (priceEl && variant && variant.price) {
        priceEl.textContent = '€ ' + (variant.price / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
    }

    form.querySelectorAll('.ny-size-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.dataset.optionIndex || '0', 10);
        form.querySelectorAll('.ny-size-btn[data-option-index="' + idx + '"]').forEach(function (b) { b.classList.remove('on'); });
        btn.classList.add('on');
        selected[idx] = btn.dataset.value;
        updateUI();
      });
    });

    form.querySelectorAll('.ny-color-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.dataset.optionIndex || '1', 10);
        form.querySelectorAll('.ny-color-btn[data-option-index="' + idx + '"]').forEach(function (b) { b.classList.remove('on'); });
        btn.classList.add('on');
        selected[idx] = btn.dataset.value;
        var label = document.querySelector('.ny-selected-color');
        if (label) label.textContent = btn.dataset.value;
        updateUI();
      });
    });

    updateUI();
  }

  // ---- Video sound toggles ----
  function initVideoSound() {
    document.querySelectorAll('.ny-sound-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var vid = document.getElementById(btn.dataset.vid);
        if (!vid) return;
        vid.muted = !vid.muted;
        btn.querySelector('.ny-sound-off').style.display = vid.muted ? '' : 'none';
        btn.querySelector('.ny-sound-on').style.display = vid.muted ? 'none' : '';
      });
    });
  }

  // ---- Init ----
  document.addEventListener('DOMContentLoaded', function () {
    initTicker();
    initScrolledNav();
    initMegaMenu();
    CartDrawer.init();
    initVideoSound();
    initPDPGallery();
    initPDPCarousel();
    initAccordions();
    initVariantPicker();
  });

})();
